module.exports = {
      id: "next-story-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#next-story",
      toString: function () {
        return this.url;
      }
    }